//For Terminal: Set-ExecutionPolicy -Scope Process -ExecutionPolicy Bypass
//Todo: Redo Vowel and Consonant Deck Icons
//Todo: add alt tags for accessibility//TSJAS

import { Link } from "react-router-dom";
import BasicWordsFolderIMG from "../assets/FolderIcons/BasicWordsFolderIMG.png";
import BasicPhrasesFolderIMG from "../assets/FolderIcons/BasicPhrasesFolderIMG.png";
import PhoneticsChartThumbnail from "../assets/HomepageMisc/PhoneticsChartThumbnail.png";
import ConsonantsFolderIMG from "../assets/FolderIcons/ConsonantsFolderIMG.png";
import VowelsFolderIMG from "../assets/FolderIcons/VowelsFolderIMG.png";
import ConsonantVowelFolderIMG from "../assets/FolderIcons/ConsonantVowelFolderIMG.png";
import MatchingGameIcon from "../assets/GameAssets/MatchingGameIcon.png";
import LetsCookIcon from "../assets/GameAssets/LetsCookIcon.png";
import ColorPopIcon from "../assets/GameAssets/ColorPopIcon.png";

import ComingSoonPopup from "../Components/ComingSoonPopup/ComingSoonPopup";

import SPLoader from "../Components/Spinner/SpinnerLoader";

import Promo_Banner_1_Home from "../assets/Banners/HomePromoBanner1IMG.png";
import Promo_Banner_2_Home from "../assets/Banners/HomePromoBanner2IMG.png";
import Promo_Banner_3_Home from "../assets/Banners/HomePromoBanner3IMG.png";
import Promo_Banner_4_Home from "../assets/Banners/HomePromoBanner4IMG.png";

import HeaderHome from "../Components/Header/Header_Home/Header_Home";
import Footer from "../Components/Footer/Footer";

import './Home.css';

import { useState, useEffect } from "react";


export default function Home() {

const [showComingSoon, setShowComingSoon] = useState(false);

function openComingSoon() {
  setShowComingSoon(true);
}

function closeComingSoon() {
  setShowComingSoon(false);
}


 const bannerImages = [
    Promo_Banner_1_Home,
    Promo_Banner_2_Home,
    Promo_Banner_3_Home,
    Promo_Banner_4_Home
  ];

  const [currentBanner, setCurrentBanner] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner((prev) =>
        prev === bannerImages.length - 1 ? 0 : prev + 1
      );
    }, 5000); // change every 5 seconds

    return () => clearInterval(interval);
  }, [bannerImages.length]);

  
  
  return (
    <>
      <SPLoader time={0.2}/>
      
      <div className="HomePage">
        <HeaderHome/>
        
        <div className="Banner-card-container">

        <div className="HomeScreenBanner">
        <img
          className="HomeScreenBannerImage"
          src={bannerImages[currentBanner]}
          alt="Flashcards Promotional Banner"
        />
      </div>

      {/* <HomeSubjectCard/> */}

        <div>
          <h1 className = "subheader-home">Hangeul Phonetics</h1>
        </div>

        <div className="CardContainer-home">

            <div className="Card-home" id="PhoneticsGreen">
              <Link to="/PhoneticsChart"> 
              <img src={PhoneticsChartThumbnail} className="CardImage-home" alt="Phonetic's Chart Thumbnail"/>
              <span id="Phonetics-Chart-diff-home">Beginner 1</span>
              
                <h2 className="cardTitle-home" id="PhoneticsChart">Phonetics Chart</h2>
                <p className="cardDescription-home">Start small and learn the basic sounds.</p>
              </Link>
            </div>

            <div className="Card-home" id="PhoneticsGreen">
              <Link to="/VowelsNav">
                <img src={VowelsFolderIMG} className="CardImage-home" alt="Vowels Folder"/>
                <span id="Phonetics-Chart-diff-home">Beginner 1</span>
                <h2 className="cardTitle-home" id="PhoneticsVowel">Vowels</h2>
                <p className="cardDescription-home">Learn vowels like ㅔ,ㅟ, and ㅙ!</p>
              </Link>
            </div>
          
            <div className="Card-home" id="PhoneticsGreen">
              <Link to="/ConsonantsNav">
                <img src={ConsonantsFolderIMG} className="CardImage-home" alt="Consonants Folder"/>
                <span id="Phonetics-Chart-diff-home">Beginner 1</span>
                <h2 className="cardTitle-home" id="PhoneticsConsonant">Consonants</h2>
                <p className="cardDescription-home">Learn consonants like ㄷ,ㅉ, and ㅅ!</p>
              </Link>
            </div>

            <div className="Card-home" id="PhoneticsGreen">
              <Link to="/ConsonantVowelPairsNav">
              <img src={ConsonantVowelFolderIMG} className="CardImage-home" alt="Consonant Vowel Folder"/>
              <span id="Phonetics-Chart-diff-home">Beginner 1</span>
              <h2 className="cardTitle-home" id="PhoneticsConsonant">Consonant-Vowel Pairs</h2>
              <p className="cardDescription-home">Learn consonant vowel pairs like 가, 서, and 또!</p>
            </Link>
          </div>

        
        </div>
        
        
        <div>
          <h1 className = "subheader-home">Basic Words & Sentences</h1>
        </div>
        
        <div className="CardContainer-home">

          <div className="Card-home">
            <Link to="/BasicWordsNav">
              <img src={BasicWordsFolderIMG} className="CardImage-home" alt="Basic Words Folder"/>
              <span className="CardDifficulty">Beginner 2</span>
              <h2 className="cardTitle-home">Basic Words</h2>
              <p className="cardDescription-home">Start learning the Korean alphabet</p>
            </Link>
          </div>
         
          <div className="Card-home" onClick={openComingSoon} style={{ cursor: "pointer" }}>
            <img src={BasicPhrasesFolderIMG} className="CardImage-home" alt="Basic Phrases Folder"/>
            <span className="CardDifficulty">Beginner 3</span>
            <h2 className="cardTitle-home">Basic Phrases</h2>
            <p className="cardDescription-home">Start learning Basic Korean Words!</p>
          </div>

          <ComingSoonPopup open={showComingSoon} onClose={closeComingSoon} />
                  
        </div>

        <div>
          <h1 className = "subheader-home">Games & Activities</h1>
        </div>

        <div className="CardContainer-home">

            <div className="Card-Game-home">
              <Link to="/MatchingGameCards">
              <img src={MatchingGameIcon} className="CardImage-home" alt="Matching Game"/>
              <span className="CardDifficulty-Game-home">Beginner 1</span>
              <h2 className="cardTitle-home">Hangeul Match</h2>
              <p className="cardDescription-home">Learn by matching hangeul characters to their english translations!</p>
              </Link>
            </div>

              <div className="Card-Game-home" onClick={openComingSoon} style={{ cursor: "pointer" }}>
                {/* <Link to="/LetsCook"> */}
                <img src={LetsCookIcon} className="CardImage-home" alt="Lets Cook Game"/>
                <span className="CardDifficulty-Game-home">Beginner 2</span>
                <h2 className="cardTitle-home">Lets Cook!</h2>
                <p className="cardDescription-home">Expand your food vocabulary by creating tasty meals!</p>
                {/* </Link>   */}
             </div>
                <ComingSoonPopup open={showComingSoon} onClose={closeComingSoon} />    

              <div className="Card-Game-home" onClick={openComingSoon} style={{ cursor: "pointer" }}>
                {/* <Link to="/ColorPop"> */}
                <img src={ColorPopIcon} className="CardImage-home" alt="Lets Cook Game"/>
                <span className="CardDifficulty-Game-home">Beginner 3</span>
                <h2 className="cardTitle-home">Color Pop!</h2>
                <p className="cardDescription-home">Blend art and language as you explore a world of colors in Korean!</p>
                {/* </Link>  */}
             </div>
                <ComingSoonPopup open={showComingSoon} onClose={closeComingSoon} />     

        </div>

      {/* 
        <Link to="/DeeperLook">
        <button>Deeper Look (testing)</button>
        </Link>

       <Link to="/">
        <button> null (testing)</button>
        </Link> */}
      
      </div>

          <Footer/>

      </div>
        </>
  );
}


//Resources:

  //use Effect, basic automation
    //https://overreacted.io/making-setinterval-declarative-with-react-hooks
  
  //More on useState ... useState(initialState)
    //https://react.dev/reference/react/useState
  
  //useEffect
    //https://www.dhiwise.com/post/understanding-the-importance-of-the-useeffect-dependency-array-in-react
  
  //Dependency Arrays
    //https://www.dhiwise.com/post/understanding-the-importance-of-the-useeffect-dependency-array-in-react
  
  //More on useState Hook
    //https://selcuk00.medium.com/common-mistakes-and-best-practices-with-reacts-usestate-hook-cd25ce2991ee